import { Button, Modal } from "react-bootstrap";

function ConfirmDeletePopup({ handleClose, handleDeleteSubmission, entity = "Entity" }) {
  return (
    <Modal
      show={true}
      onHide={handleClose}
      dialogClassName=" modal-dialog-centered"
      contentClassName="custom-modal-new-provider"
      size="md"
    >
      <div>
        <Modal.Header
          style={{ borderBottom: "0px" }}
          className="text-center height-25 p-0 bg-primary popup-heading-color justify-content-center"
        >
          <Modal.Title
            className="mx-auto height-25 font-weight-semibold text-uppercase popup-heading-color d-flex align-items-center"
            style={{ fontSize: "14px", fontWeight: "600" }}
          >
            Delete {entity}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body className="p-0 m-t-5 m-l-5 m-r-5 m-b-5">
          <div className="custom-tab">
            <div
              className="d-flex align-items-center"
              style={{
                fontSize: "14px",
                fontWeight: "600",
                color: "var(--primary)",
                padding: "5px",
              }}
            >
              This will delete the {entity} from the case and move any documents attached to this{" "}
              {entity} to being unsorted attached to the case generally.
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer
          className="p-0 mt-0 padding-outside-btn-new-provider"
          style={{ borderTop: "none" }}
        >
          <Button
            className="button-padding-footer-new-provider d-flex align-items-center justify-content-center"
            variant="secondary"
            onClick={handleClose}
          >
            CANCEL
          </Button>
          <Button
            variant="danger"
            className="button-padding-footer-new-provider d-flex align-items-center justify-content-center"
            onClick={handleDeleteSubmission}
          >
            DELETE {entity}
          </Button>
        </Modal.Footer>
      </div>
    </Modal>
  );
}

export default ConfirmDeletePopup;
